// extracted by mini-css-extract-plugin
export default {"container":"AttorneysList_container__Si4Je","input":"AttorneysList_input__PuFoA","scroll-container":"AttorneysList_scroll-container__W7v+n","scroll":"AttorneysList_scroll__Cw8En"};